<template>
  <v-card>
    <v-layout>
      <v-app-bar title="ONEPLAN Админка"></v-app-bar>

      <Navigation />

      <v-main style="min-height: calc(100vh - 100px)">
        <v-container fluid>
          <v-card>
            <v-card-title>Категории</v-card-title>
            <v-card-text>
              <CategoriesList />
            </v-card-text>
          </v-card>
        </v-container>
      </v-main>
    </v-layout>
  </v-card>
</template>
<script>
import Navigation from "@/components/Navigation";
import CategoriesList from "@/components/Categories/CategoriesList.vue";
export default {
  components: {
    Navigation,
    CategoriesList
  },
};
</script>
